// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	// var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	// var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
	// 	return new bootstrap.Popover( popoverTriggerEl, {
	// 		trigger: 'focus',
	// 	} );
	// } );

	$('.filter-inputs').on('change', function(e) {
		var selected = [];
		// Loop all selected filters
		$('.filter-inputs input:checked').each(function(index, element) {
			selected.push($(this).val());
		})
		// If there a no selected filters, show all products
		if(selected.length == 0) {
			$('.filter-products .products li.product').fadeIn();
			return;
		}

		$('.filter-products .products li.product').each(function(index, element) {
			var categories = $(this).data('taxonomies').toString();
			var category_ids = categories.split(',');
			// Check to see if any of the selected category ids, exist on the product
			var contains = selected.findIndex(element => category_ids.includes(element));
			// findIndex returns -1 if no index is found. 0 is first in array.
			if(contains > -1) {
				// $(this).show({duration: 'slow', easing: 'linear'});
				$(this).fadeIn('slow');
				// $(this).slideDown();
			} else {
				$(this).fadeOut('slow');
				// $(this).hide({duration: 'slow', easing: 'linear'});
				// $(this).slideUp();
			}
		});
	});

	$('.navbar-nav ul.dropdown-menu .dropdown-toggle').on('click', function(event) {
		event.preventDefault();
		event.stopPropagation();
		console.log('clicked dropdown');
		$(this).parent().siblings().removeClass('open');
		$(this).parent().toggleClass('open');
	});

} )();